export default __webpack_public_path__ + "static/DanzzaBold-947415f5014412636bcacc185f7091a7.svg";